<script>
   /*************************************************************/
   /* PlotEigenvalues                                           */
   /* --------------------                                      */
   /* shows plot with eigenavalues vs. number of PCs            */
   /*************************************************************/

   import { Vector } from 'mdatools/arrays';
   import { pcamodel_get } from '../wasm/dist/pca.js';
   import { FACE_COLORS } from './Defaults.js';

   import PlotSeries from './PlotSeries.svelte';
   import Axes from './Axes.svelte';

   let {
      params,                        // JSON with main plot parameters
      callbacks,                     // JSON with all callback methods
      props,                         // JSON with main properties (model, results, dataset)
      selected,                      // ID of selected object
   } = $props();

   // get the parameters needed for the plot
   let model = $derived(props ? props.model : null);

   // constant plot parameters
   const yLabels = {'none': 'λ', 'log':  'log(λ)', 'sqrt': 'sqrt(λ)'};


   function f(values, transform) {
      const dof = model.nrows - 1;
      if (transform === 'none') return values.apply(v => v * dof);
      if (transform === 'log') return values.apply(v => Math.log(v * dof))
      if (transform === 'sqrt') return values.apply(v => Math.sqrt(v * dof))
   }

   // reactive computation of y limits
   let eigenvalues = $derived(model ? new Vector(pcamodel_get(model, 'eigenvals')) : null);
   let xValues = $derived(model ? Vector.seq(1, model.ncomp) : null);
   let yValues = $derived(eigenvalues ? f(eigenvalues, params.transform) : null);
   let labels = $derived(yValues ? Array.from(yValues.v).map(v => v.toFixed(v < 0.1 ? 3 : 2)) : null);

   const dX = $derived(model.ncomp > 10 ? model.ncomp * 0.05 : 0.5)
   const xMin = $derived(model.ncomp > 1 ? 1 : 0);
   const xMax = $derived(model.ncomp > 1 ? model.ncomp : 2);
   const limX = $derived([xMin - dX, xMax + dX]);

   let minY = $derived(yValues ? (params.transform === 'none' ? 0 : yValues.v[model.ncomp - 1]) : 0);
   let maxY = $derived(yValues ? yValues.v[0] : 1);
   let dY = $derived((maxY - minY) / 18);
   let limY = $derived(yValues ? [minY - dY, maxY +  dY] : [0, 1]);
   let yLabel = $derived(yLabels[params.transform]);
</script>

{#if xValues && yValues }
<Axes {limX} {limY} {yLabel} whole={true} xLabel="Number of PCs" title="Eigenvalues" fileName="plot-eigenvalues">

   <!-- data points  -->
   <PlotSeries
      {xValues}
      {yValues}
      {labels}
      plotType={params.plotType}
      showLabels={params.showLabels}
      faceColor={FACE_COLORS['cal']}
      lineWidth={1.5}
   />
</Axes>
{/if}